import { useCallback } from 'react';
import { navigate } from '../router';
import { LOGIN_SIGNUP_VIEW } from '@app/constants';
import { collectAutoSaveImages } from '@app/utils/utils';

const useSaveToYourAccount = ({
  flow,
  context,
  flowConfig,
  finishArtwork,
  processFinishedArtwork,
  isAuthorized,
  matrix,
  setFooterConfig,
}) => {
  const navigateToLoginSignup = useCallback(() => {
    sessionStorage.setItem('prevView', matrix.view);
    navigate(LOGIN_SIGNUP_VIEW, {}, true);
  }, [matrix.view]);

  const finishArtworkProject = useCallback(
    async saveToYourAccount => {
      if (saveToYourAccount) {
        if (isAuthorized) {
          const {
            projectTransformer: { selector },
          } = context;

          const artworkData = await finishArtwork(flow, context, flowConfig);
          collectAutoSaveImages(flow, selector, artworkData);

          await flow.saveProjectImages();
          await processFinishedArtwork(artworkData, flow, flowConfig);
        } else {
          setFooterConfig({ backLocKey: 'qau-cancel-btn', showSaveToMyAccount: false });
          navigateToLoginSignup();
        }
      } else {
        const artworkData = await finishArtwork(flow, context, flowConfig);
        await processFinishedArtwork(artworkData, flow, flowConfig);
      }
    },
    [
      isAuthorized,
      context,
      finishArtwork,
      flow,
      flowConfig,
      processFinishedArtwork,
      setFooterConfig,
      navigateToLoginSignup,
    ],
  );

  return {
    finishArtworkProject,
    navigateToLoginSignup,
  };
};

export default useSaveToYourAccount;
